export default "__VITE_ASSET__aYBShPMw__"